import React, { useState } from 'react';

import {
  perPageOptions as defaultPerPageOptions,
} from './TablePagination.config';

import TablePagination from './TablePagination';

type PerPageOption = { label: string; value: number };

const TablePaginationContainer = ({
  currentPage,
  perPage,
  totalPages,
  onPerPageChange,
  perPageOptions = defaultPerPageOptions,
  ...restProps
}: {
  currentPage: any;
  perPage: any;
  totalPages: any;
  onPerPageChange: any;
  perPageOptions?: PerPageOption[];
} & Record<string, any>) => {
  const [currentPerPage, setCurrentPerPage] = useState(
    perPageOptions.find((option: PerPageOption) => option.value === perPage),
  );

  const handlePerPageChange = (nextPerPage: any) => {
    setCurrentPerPage(nextPerPage);

    if (onPerPageChange) {
      onPerPageChange(nextPerPage.value);
    }
  };

  const nextPageDisabled = currentPage === totalPages;
  const prevPageDisabled = currentPage === 1;

  return (
    <TablePagination
      {...restProps}
      prevPageDisabled={prevPageDisabled}
      nextPageDisabled={nextPageDisabled}
      currentPage={currentPage}
      totalPages={totalPages}
      currentPerPage={currentPerPage}
      perPageOptions={perPageOptions}
      onPerPageChange={handlePerPageChange}
    />
  );
};

export default React.memo(TablePaginationContainer) as any;
